import {SchemeLink} from '../../../applink/SchemeLink';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {StrategyCategoryItemProps} from './StrategyCategoryItemProps';

export function StrategyCategoryItem({
  className,
  title,
  count,
  scheme,
  ...props
}: StrategyCategoryItemProps) {
  return (
    <SchemeLink scheme={scheme || undefined}>
      <div
        className={twMerge(
          'flex h-44pxr cursor-pointer flex-row items-center justify-center bg-theme-solid-10',
          className
        )}
        {...props}
      >
        <Text className="font-medium2 text-theme-solid-100 line-clamp-1">
          {title || ''}
        </Text>
        {count !== undefined && (
          <Text className="font-small1 ml-4pxr text-theme-solid-100">
            {count}
          </Text>
        )}
      </div>
    </SchemeLink>
  );
}
